import { combineReducers } from "redux";

const defaultParams = {
  searchFetched: false,
  isSearching: false,
};

function searchedResults(state = {}, action) {
  if (action.type === "STORE_LEDGER_RESULT") {
    return {
      ...state,
      [action.name]: action.payload,
    };
  } else {
    return state;
  }
}

// Store loading state per field name instead of global
function loadingByField(state = {}, action) {
  if (action.type === "SEARCH_LEDGER") {
    return {
      ...state,
      [action.name]: true, // Set loading for this specific field
    };
  }
  if (action.type === "STORE_LEDGER_RESULT") {
    return {
      ...state,
      [action.name]: false, // Set loading false for this specific field
    };
  } else {
    return state;
  }
}

// Keep legacy params reducer for backward compatibility
function params(state = defaultParams, action) {
  if (action.type === "SEARCH_LEDGER") {
    return {
      ...state,
      searchFetched: false,
      isSearching: true,
    };
  }
  if (action.type === "STORE_LEDGER_RESULT") {
    return {
      ...state,
      searchFetched: true,
      isSearching: false,
    };
  } else {
    return state;
  }
}

const ledgerSearchReducer = combineReducers({
  searchedResults,
  loadingByField, // Add per-field loading state
  params,
});

export default ledgerSearchReducer;
